export default {
    root: function (_a) {
        var _b;
        var props = _a.props;
        return ({
            class: [
                // Flex & Alignment
                'tw-inline-flex tw-justify-center tw-items-center',
                'tw-text-center',
                // Font
                'tw-font-medium',
                {
                    'tw-text-md tw-leading-[1.75rem]': props.size === null,
                    'tw-text-sm tw-leading-[1.25rem]': props.size === 'small',
                    'tw-text-lg tw-leading-[2.25rem]': props.size === 'large',
                    'tw-text-2xl tw-leading-[3rem]': props.size === 'xlarge',
                },
                // Size
                'tw-p-0',
                {
                    'tw-min-w-7 tw-h-7': props.size === null,
                    'tw-min-w-5 tw-h-5': props.size === 'small',
                    'tw-min-w-9 tw-h-9': props.size === 'large',
                    'tw-min-w-12 tw-h-12': props.size === 'xlarge',
                },
                // Shape
                (typeof props.value === 'string' && ((_b = props.value) === null || _b === void 0 ? void 0 : _b.length) === 1) || (typeof props.value === 'number' && props.value < 10)
                    ? 'tw-rounded-full tw-px-1'
                    : 'tw-rounded-[0.71rem] tw-px-2',
                // Color
                {
                    'tw-bg-primary-500 tw-text-white': props.severity === null || props.severity === 'primary',
                    'tw-bg-gray-500 dark:tw-bg-gray-400': props.severity === 'secondary',
                    'tw-bg-green-500 tw-text-white dark:tw-bg-green-400': props.severity === 'success',
                    'tw-bg-blue-500 dark:tw-bg-blue-400': props.severity === 'info',
                    'tw-bg-amber-500 tw-text-white dark:tw-bg-amber-400': props.severity === 'warn',
                    'tw-bg-purple-500 dark:tw-bg-purple-400': props.severity === 'help',
                    'tw-bg-red-500 dark:tw-bg-red-400': props.severity === 'danger',
                    'tw-text-gray-0 dark:tw-text-gray-900 tw-bg-gray-900 dark:tw-bg-gray-0': props.severity === 'contrast',
                },
            ],
        });
    },
};
